// @flow
import React, { useState } from "react";
import { Card, Button, CardTitle, Row, Col } from "reactstrap";
import Octicon, { File, Plus } from "@githubprimer/octicons-react";
import { useNavigation, useCurrentRoute } from "react-navi";

export function CreateConfig(props) {
  const navigation = useNavigation();
  const route = useCurrentRoute();

  function navigate(choice) {
    const endpoint = `/machines/${route.data.machineId}/configs/create`;
    switch (choice) {
      case 1:
        navigation.navigate(`${endpoint}?new=false&page=1`);
        break;
      case 2:
        navigation.navigate(`${endpoint}?new=true`);
        break;
      default:
        navigation.navigate(endpoint);
        break;
    }
  }

  return (
    <div className="mt-5 mb-5 container d-flex justify-content-center">
      <Col className="justify-content-center d-flex">
        <Card
          outline
          color="dark"
          className="card-chart justify-content-center align-self-center col-md-12 card-black"
        >
          <CardTitle className="mt-3 justify-content-center d-flex">
            <h3 style={{ textAlign: "center" }}>
              <b>How would you like to create the configuration?</b>
            </h3>
          </CardTitle>
          <hr className="hr-black" style={{ marginTop: 0 }} />
          <Row style={{ marginBottom: "10px" }}>
            <Col md="6" xs="12" style={{ marginBottom: "5px" }}>
              <Button
                onClick={() => navigate(1)}
                block
                outline
                color="dark"
                className="btn-lg-black"
              >
                <Row className="d-flex justify-content-center">
                  <Octicon size="medium" icon={File} />
                </Row>
                <Row className="d-flex justify-content-center">
                  FROM TEMPLATE
                </Row>
              </Button>
            </Col>
            <Col>
              <Button
                onClick={() => navigate(2)}
                block
                outline
                color="dark"
                className="btn-lg-black"
              >
                <Row className="d-flex justify-content-center">
                  <Octicon size="medium" icon={Plus} />
                </Row>
                <Row className="d-flex justify-content-center">
                  FROM SCRATCH
                </Row>
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/Configuration/configCreate.jsx